var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBackarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B9B9B9",
    d: "M11.259,496.259C11.259,766.183,230.075,985,499.999,985c269.925,0,488.741-218.816,488.741-488.742 c0-269.924-218.816-488.74-488.741-488.74C230.075,7.519,11.258,226.335,11.259,496.259z M577.544,162.375 c0,18.99-7.244,37.979-21.732,52.468l-206.771,206.77h481.051c41.229,0,74.648,33.42,74.648,74.646 c0,41.227-33.42,74.647-74.646,74.647H349.041l206.771,206.771c28.978,28.978,28.978,75.958,0,104.935 c-28.979,28.978-75.958,28.978-104.936,0L116.992,548.727c-13.915-13.915-21.732-32.789-21.732-52.467c0-0.001,0,0,0-0.001 c0-19.679,7.816-38.553,21.732-52.467l333.884-333.884c28.978-28.979,75.958-28.979,104.936,0 C570.3,124.396,577.544,143.386,577.544,162.375z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackarrow);
export default __webpack_public_path__ + "static/media/icon-backarrow.fd4368e172bee79f377cf015f7ddc8d8.svg";
export { ForwardRef as ReactComponent };